import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';
import { useAuthHttp } from '../../hooks';
import { VEHICLE_CREATE } from '../../constants';
import {
  VehicleForm,
  VehicleFormValues,
  toOptionalNumber,
} from '../../forms/VehicleForm/VehicleForm';

export function AddVehicle() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const prefilledType = searchParams.get('type');
  const authHttpFormData = useAuthHttp('multipart/form-data');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useDocumentTitle('FLOX - New Vehicle');

  const pages = [
    { name: 'Home', href: '/', current: false },
    { name: 'Vehicles', href: '/fleet-master', current: false },
    { name: 'Add New Vehicle', href: '#', current: true },
  ];

  const handleOnSubmit = async (data: VehicleFormValues) => {
    setIsSubmitting(true);
    try {
      const payload = {
        vehicle: {
          model: data.model,
          registrationNumber: data.registrationNumber,
          vehicleType: data.vehicleType,
          vehicleCategory: data.vehicleCategory.value,
          specialEquipment: data.specialEquipment.map((eq) => eq.value),
          vehicleCapacity: {
            maxCapacityDimensions: {
              width: toOptionalNumber(data.width),
              length: toOptionalNumber(data.length),
              height: toOptionalNumber(data.height),
              dimensionsUnitOfMeasure: data.dimensionsUnitOfMeasure.value,
            },
            maxPallets: toOptionalNumber(data.maxPallets),
            maxKilograms: toOptionalNumber(data.maxKilograms),
          },
          fuelType: data.fuelType.value,
          emissionStandard: data.emissionStandard.value,
          averageAnnualMileage: toOptionalNumber(data.averageAnnualMileage),
          averageAnnualMileageUnits: data.averageAnnualMileageUnits.value,
        },
        images: data.vehicleImage
          ? [
              {
                id: crypto.randomUUID(),
                title: data.vehicleImage.name,
                image: data.vehicleImage,
              },
            ]
          : [],
      };

      await authHttpFormData.post(VEHICLE_CREATE, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      navigate('/fleet-master');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <VehicleForm
      onSubmit={handleOnSubmit}
      isSubmitting={isSubmitting}
      header='New Vehicle'
      pages={pages}
      initialValues={prefilledType ? { vehicleType: prefilledType } : undefined}
    />
  );
}
